import { Button, Card, CardContent, CardHeader, Divider } from '@material-ui/core';
// import CloseIcon from '@material-ui/icons/Close';
// import DeleteIcon from '@material-ui/icons/DeleteOutline';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { CreateTransactionModal } from 'components';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {},
  mainActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  notice: {
    marginTop: theme.spacing(1)
  },
  deleteButton: {
    marginTop: theme.spacing(1),
    color: theme.palette.white,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  },
  closeButton: {
    marginTop: theme.spacing(1),
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  }
}));
let mounted = false;

const OtherActions = props => {
  const { className, handleDelete, reload, ...rest } = props;
  // const [deleteState, setDeleteState] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const model = useSelector(state => state.models.wallet);
  const classes = useStyles();

  // const handleDeleteConfirm = () => {
  //   if (deleteState) return handleDelete();
  //   mounted && setDeleteState(!deleteState);
  // }

  const handleTransactionCreateClose = () => {
    mounted && setShowCreateModal(false);
  }

  const handleTransactionCreateOpen = () => {
    mounted && setShowCreateModal(true);
  }

  useEffect(() => {
    mounted = true;
    return () => { mounted = false };
  }, []);


  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Other actions" />
      <Divider />
      <CardContent>
        <Button fullWidth className={classes.closeButton} onClick={handleTransactionCreateOpen}>
          Create Transaction
        </Button>
        {/* {deleteState &&
          <Button fullWidth className={classes.closeButton} onClick={() => setDeleteState(false)}>
            <CloseIcon className={classes.buttonIcon} />
            Cancel
        </Button>}
        <Button fullWidth className={classes.deleteButton} onClick={handleDeleteConfirm}>
          <DeleteIcon className={classes.buttonIcon} />
          {deleteState ? "Confirm" : "Delete Wallet"}
        </Button> */}
      </CardContent>
      <CreateTransactionModal onClose={handleTransactionCreateClose} onCreate={reload} open={showCreateModal} wallet_id={model.id} />
    </Card>
  );
};

OtherActions.propTypes = {
  className: PropTypes.string
};

export default OtherActions;
